import * as ActionTypes from './types.action';

export const uploadInvoice = files => ({
  type: ActionTypes.UPLOAD_INVOICE_REQUESTED,
  files,
});

export const uploadInvoiceSuccess = response => ({
  type: ActionTypes.UPLOAD_INVOICE_SUCCESS,
  response,
});

export const uploadInvoiceFailure = error => ({
  type: ActionTypes.UPLOAD_INVOICE_FAILED,
  error,
});

export const uploadInvoiceReset = () => ({
  type: ActionTypes.UPLOAD_INVOICE_RESET,
});

export const fetchUploadedInvoices = (page = 0) => ({
  type: ActionTypes.FETCH_UPLOADED_INVOICES_REQUESTED,
  page,
});

export const fetchUploadedInvoicesSuccess = data => ({
  type: ActionTypes.FETCH_UPLOADED_INVOICES_SUCCESS,
  data,
});

export const fetchUploadedInvoicesFailure = error => ({
  type: ActionTypes.FETCH_UPLOADED_INVOICES_FAILED,
  error,
});

export const fetchUploadedInvoiceDetail = id => ({
  type: ActionTypes.FETCH_UPLOADED_INVOICE_DETAIL_REQUESTED,
  id,
});

export const fetchUploadedInvoiceDetailSuccess = data => ({
  type: ActionTypes.FETCH_UPLOADED_INVOICE_DETAIL_SUCCESS,
  data,
});

export const fetchUploadedInvoiceDetailFailure = error => ({
  type: ActionTypes.FETCH_UPLOADED_INVOICE_DETAIL_FAILED,
  error,
});
